import { Injectable } from '@angular/core';
import {
    Country,
    ICommonLocationService,
    ITypedResponse,
    LocationEdit,
    LocationModel,
    State
} from '@caslink/common-client';
import { ProxyService } from '../proxy/ProxyService';

// Provides access to location services that are used by multiple
// application areas.
@Injectable({
    providedIn: 'root'
})
export class CommonLocationService implements ICommonLocationService {
    public static $name: string = 'commonLocationService';

    constructor(
        private proxyService: ProxyService
    ) {
    }

    getCountries(): angular.IPromise<Country[]> {
        return this.proxyService.request({
            endPoint: 'location',
            route: 'getCountries'
        }).asArray<Country>();
    }

    getStatesForCountry(countryId: number): angular.IPromise<State[]> {
        return this.proxyService.request({
            endPoint: 'location',
            route: 'getStatesForCountry',
            routeParams: {
                countryId: countryId
            }
        }).asArray<State>();
    }

    getLocation(locationId: number): angular.IPromise<LocationModel> {
        return this.proxyService.request({
            endPoint: 'location',
            route: 'getLocation',
            routeParams: { locationId: locationId }
        }).as<LocationModel>();
    }

    getAuthenticatedUserInfo(): angular.IPromise<CASLink.Infrastructure.Ui.ViewModel.Users.AuthenticatedUserInfoViewModel> {
        return this.proxyService.request({
            endPoint: 'locationUser', route: 'getAuthenticatedUserInfo'
        }).as<CASLink.Infrastructure.Ui.ViewModel.Users.AuthenticatedUserInfoViewModel>();
    }

    updateAreaName(locationId: number, locationAreaId: number, areaName: string): angular.IPromise<ITypedResponse<string>> {
        return this.proxyService.request({
            data: {
                areaName: areaName,
            },
            endPoint: 'location',
            route: 'updateAreaName',
            routeParams: {
                locationAreaId: locationAreaId,
                locationId: locationId
            }
        }).as<ITypedResponse<string>>();
    }

    deleteArea(locationAreaId: number): angular.IPromise<ITypedResponse<string>> {
        return this.proxyService.request({
            endPoint: 'location',
            route: 'deleteArea',
            routeParams: {
                locationAreaId: locationAreaId,
            }
        }).as<ITypedResponse<string>>();
    }

    getLocationEdit(locationId: number): angular.IPromise<LocationEdit> {
        let locationEdit: LocationEdit;

        return this.proxyService.request({
            endPoint: 'location', route: 'getLocationEdit',
            routeParams: { locationid: locationId }
        }).as<LocationEdit>().then(result => {

            locationEdit = {
                canEditCustomer: result.canEditCustomer,
                canEditIsCertified: result.canEditIsCertified,
                canEditIsAirQualityExcellence: result.canEditIsAirQualityExcellence,
                location: result.location
            };

            return this.getStatesForCountry(locationEdit.location.countryId);
        }).then(states => {
            locationEdit.states = states;
            return locationEdit;
        });
    }

    updateLocation(location: LocationModel): angular.IPromise<ITypedResponse<string>> {
        return this.proxyService.request({
            endPoint: 'location', route: 'updateLocation',
            data: location
        }).as<ITypedResponse<string>>();
    }

    getLocationSubscriptionUrl(locationId: number): angular.IPromise<string> {
        return this.proxyService.request({
            endPoint: 'location',
            route: 'getSubscriptionUrl',
            routeParams: {
                locationId: locationId
            }
        }).as<string>();
    }
}
